import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./Admin/auth/login/reducer";
import CheckAuthType from "./Admin/auth/checkAuthType/reducer";
import ForgetPassword from "./Admin/auth/forgetpwd/reducer";
import Profile from "./Admin/auth/profile/reducer";


//Dashboard 
import Dashboard from "./dashboard/reducer";

// Aspiration Question
import AspirationQuestion from "./Admin/aspirations/aspirationsQuestion/reducer"
// Aspiration Question
import SchorHorizontal from "./Admin/aspirations/schorHorizontal/reducer"
// Aspiration Question
import SchorVertical from "./Admin/aspirations/schorVertical/reducer"

// Questionnaire
import Questionnaire from "./Admin/questionnaire/reducer"

// Invitations
// Partcipants Invites
import ParticipantsInvites from "./Admin/Invitations/Participants/Invites/reducer"
// Raters Invites
import RatersInvites from "./Admin/Invitations/Raters/Invites/reducer"

// Reminders
// Partcipants Reminders
import ParticipantsReminders from "./Admin/Reminders/Participants/reducer"

// Batches
import Batches from "./Admin/batches/reducer"

// Email
import Email from "./Admin/email/reducer"

// Norms
import Norms from "./Admin/email copy/reducer"

//Configuration Language
import configurationsLanguages from "./Admin/configurations/language/reducer"

//Configuration ChartColor
import ConfigurationsChartColor from "./Admin/configurations/ChartColor/reducer"

//Survey text welcome
import configSurveyWelcome from "./Admin/configurations/surveytext/welcome/reducer"

//Survey text welcome
import configSurveyMiddle from "./Admin/configurations/surveytext/middle/reducer"

// Survey text welcome
import configSurveyThankYou from "./Admin/configurations/surveytext/thankyou/reducer"

// Config Raters Type
import configRatersType from "./Admin/configurations/raterstype/reducer"

// ******************************** => Participant // Rater Panel <= **************************************
// Authentication
import ParticipantLogin from "./Participant/auth/login/reducer";
import ParticipantForgetPassword from "./Participant/auth/forgetpwd/reducer";
import ParticipantProfile from "./Participant/auth/profile/reducer";

// raters invite
import RatersInvite from "./Participant/RatersInvite/reducer";
import Survey from "./Participant/CompleteSelfServey/reducer";


const rootReducer = combineReducers({
  Layout,
  Login,
  CheckAuthType,
  ForgetPassword,
  Profile,
  Dashboard,
  AspirationQuestion,
  SchorHorizontal,
  SchorVertical,
  Questionnaire,
  ParticipantsInvites,
  ParticipantsReminders,
  RatersInvites,
  configurationsLanguages,
  configSurveyWelcome,
  configSurveyMiddle,
  configSurveyThankYou,
  ConfigurationsChartColor,
  configRatersType,
  Batches,
  Email,
  Norms,
// ******************************** => Participant // Rater Panel <= **************************************
  ParticipantLogin,
  ParticipantForgetPassword,
  ParticipantProfile,
  RatersInvite,
  Survey
});

export default rootReducer;
